import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const genericFieldDefaultVariants = {}
const genericFieldCompoundVariants = []

const genericFieldSlotNames = [
  [
    "container",
    "Field__container"
  ],
  [
    "main",
    "Field__main"
  ],
  [
    "label",
    "Field__label"
  ],
  [
    "value",
    "Field__value"
  ],
  [
    "icon",
    "Field__icon"
  ],
  [
    "errorMessage",
    "Field__errorMessage"
  ]
]
const genericFieldSlotFns = /* @__PURE__ */ genericFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, genericFieldDefaultVariants, getSlotCompoundVariant(genericFieldCompoundVariants, slotName))])

const genericFieldFn = memo((props = {}) => {
  return Object.fromEntries(genericFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const genericFieldVariantKeys = [
  "error",
  "disabled",
  "menuOpen"
]
const getVariantProps = (variants) => ({ ...genericFieldDefaultVariants, ...compact(variants) })

export const genericField = /* @__PURE__ */ Object.assign(genericFieldFn, {
  __recipe__: false,
  __name__: 'genericField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: genericFieldVariantKeys,
  variantMap: {
  "error": [
    "true"
  ],
  "disabled": [
    "true"
  ],
  "menuOpen": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, genericFieldVariantKeys)
  },
  getVariantProps
})